export const types = {
    SET_LOADER: "SET_LOADER",
    UNSET_LOADER: "UNSET_LOADER"
}
